import { getSizedImageUrl } from './product-item.js';

export const selectors$4 = {
  productCutline: '[data-product-cutline]',
  productLink: '[data-product-link]',
  productGridItem: '[data-grid-item]',
  productInfo: '[data-product-information]',
  productImage: '[data-product-image-default]',
  productImageSibling: '[data-product-image-sibling]',
  productPrice: '[data-product-price]',
  siblingsInnerHolder: '[data-sibling-inner]',
  siblingCount: '[data-sibling-count]',
  siblingFieldset: '[data-sibling-fieldset]',
  siblingLink: '[data-sibling-link]',
  siblingLinkCurrent: '.sibling__link--current',
};

export const classes$4 = {
  visible: 'is-visible',
  fade: 'is-fade',
  stopEvents: 'no-events',
  active: 'is-active',
  isFocused: 'is-focused',
};

export const attributes$3 = {
  siblingAddedImage: 'data-sibling-added-image',
  siblingCutline: 'data-sibling-cutline',
  siblingImage: 'data-sibling-image',
  siblingPrice: 'data-sibling-price',
  siblingCompareAtPrice: 'data-sibling-compare-at-price',
  productLink: 'data-product-link',
  siblingLink: 'data-sibling-link',
  mobileColumnsSmall: 'data-mobile-columns-small',
  anySiblingCutline: 'data-any-sibling-cutline',
};

export class SiblingSwatches {
  constructor(swatches, product) {
    this.swatches = swatches;
    this.product = product;
    this.productLinks = this.product.querySelectorAll(selectors$4.productLink);
    this.productCutline = this.product.querySelector(selectors$4.productCutline);
    this.productPrice = this.product.querySelector(selectors$4.productPrice);
    this.productImage = this.product.querySelector(selectors$4.productImage);
    this.productImageSibling = this.product.querySelector(selectors$4.productImageSibling);
    this.siblingsInnerHolder = this.product.querySelector(selectors$4.siblingsInnerHolder);

    this.init();
  }

  init() {
    this.cacheDefaultValues();

    this.siblingsInnerHolder.addEventListener('mouseleave', () => this.resetProductValues());
    this.siblingsInnerHolder.addEventListener('focusout', () => {
      if (document.body.classList.contains(classes$4.isFocused)) this.resetProductValues();
    });

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', (event) => this.showSibling(event));
      swatch.addEventListener('focusin', (event) => {
        if (document.body.classList.contains(classes$4.isFocused)) this.showSibling(event);
      });
    });

    if (this.productLinks.length) {
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          this.productLinks[0].click();
        });
      });
    }
  }

  cacheDefaultValues() {
    this.activeSibling = this.siblingsInnerHolder.querySelector(selectors$4.siblingLinkCurrent)?.closest(selectors$4.siblingLink);
    if (this.activeSibling) {
      this.productImageSibling.setAttribute(attributes$3.siblingImage, this.activeSibling.dataset.siblingImage);
    }

    this.productLinkValue = this.productLinks[0].hasAttribute(attributes$3.productLink) ? this.productLinks[0].getAttribute(attributes$3.productLink) : '';
    this.productPriceValue = this.productPrice.innerHTML;

    if (this.productCutline) {
      this.productCutlineValue = this.productCutline.innerHTML;
      this.anySiblingCutline = this.productCutline.getAttribute(attributes$3.anySiblingCutline) === 'true';
    }
  }

  resetProductValues() {
    this.product.classList.remove(classes$4.active);

    if (this.productLinkValue) {
      this.productLinks.forEach((productLink) => {
        productLink.href = this.productLinkValue;
      });
    }

    if (this.productPrice) {
      this.productPrice.innerHTML = this.productPriceValue;
    }

    if (this.productCutline && this.productCutline) {
      this.productCutline.innerHTML = this.productCutlineValue;
      this.productCutline.title = this.productCutlineValue;
    }

    this.hideSiblingImage();
  }

  showSibling(event) {
    const swatch = event.target;
    const siblingLink = swatch.hasAttribute(attributes$3.siblingLink) ? swatch.getAttribute(attributes$3.siblingLink) : '';
    const siblingPrice = swatch.hasAttribute(attributes$3.siblingPrice) ? swatch.getAttribute(attributes$3.siblingPrice) : '';
    const siblingCompareAtPrice = swatch.hasAttribute(attributes$3.siblingCompareAtPrice) ? swatch.getAttribute(attributes$3.siblingCompareAtPrice) : '';
    const siblingCutline = swatch.hasAttribute(attributes$3.siblingCutline) ? swatch.getAttribute(attributes$3.siblingCutline) : '';
    const siblingImage = swatch.hasAttribute(attributes$3.siblingImage) ? swatch.getAttribute(attributes$3.siblingImage) : '';

    if (siblingLink) {
      this.productLinks.forEach((productLink) => {
        productLink.href = siblingLink;
      });
    }

    if (siblingCompareAtPrice) {
      this.productPrice.innerHTML = `<span class="price sale"><span class="new-price">${siblingPrice}</span> <span class="old-price">${siblingCompareAtPrice}</span></span>`;
    } else {
      this.productPrice.innerHTML = `<span class="price">${siblingPrice}</span>`;
    }

    if (this.productCutline) {
      if (siblingCutline) {
        this.productCutline.innerHTML = siblingCutline;
        this.productCutline.title = siblingCutline;
      } else {
        // Use &nbsp; to reserve space when any sibling has a cutline, preventing CLS
        const anySiblingCutline = this.productCutline.getAttribute(attributes$3.anySiblingCutline) === 'true';
        this.productCutline.innerHTML = anySiblingCutline ? '&nbsp;' : '';
        this.productCutline.title = '';
      }
    }

    if (siblingImage) {
      this.showSiblingImage(siblingImage);
    }
  }

  showSiblingImage(siblingImage) {
    if (!this.productImageSibling) return;

    // Add current sibling swatch image to PGI image
    const ratio = window.devicePixelRatio || 1;
    const pixels = this.productImage.offsetWidth * ratio;
    const widthRounded = Math.ceil(pixels / 180) * 180;
    const imageSrc = getSizedImageUrl(siblingImage, `${widthRounded}x`);
    const imageExists = this.productImageSibling.querySelector(`[src="${imageSrc}"]`);
    const showCurrentImage = () => {
      this.productImageSibling.classList.add(classes$4.visible);
      this.productImageSibling.querySelector(`[src="${imageSrc}"]`).classList.add(classes$4.fade);
    };
    const swapImages = () => {
      const activeSiblingImage = this.productImageSibling.getAttribute(attributes$3.siblingImage);
      const swapNewImageOnHover = siblingImage !== activeSiblingImage;
      const swapActiveSiblingImage = siblingImage === activeSiblingImage && this.productImageSibling.classList.contains(classes$4.visible);

      // Avoid changing the image when hovering over the currently active sibling link, if the featured image remains unchanged.
      const shouldSwap = Boolean(swapActiveSiblingImage || swapNewImageOnHover);

      if (!shouldSwap) return;

      this.productImageSibling.querySelectorAll('img').forEach((image) => {
        image.classList.remove(classes$4.fade);
      });
      requestAnimationFrame(showCurrentImage);
    };

    if (imageExists) {
      swapImages();
    } else {
      const imageTag = document.createElement('img');

      imageTag.src = imageSrc;

      if (this.productCutline) {
        imageTag.alt = this.productCutline.innerText;
      }

      imageTag.addEventListener('load', () => {
        this.productImageSibling.append(imageTag);

        swapImages();
      });
    }
  }

  hideSiblingImage() {
    if (!this.productImageSibling) return;

    this.productImageSibling.classList.remove(classes$4.visible);
    this.productImageSibling.querySelectorAll('img').forEach((image) => {
      image.classList.remove(classes$4.fade);
    });
  }
}
